<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-insumo') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="produtosSelecionados.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>
        <br />
        <div class="columns">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="alqueireInput"
                    title="consumoalqueire"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="consumoalqueire"
                    @input="alqueireUpdate"
                    :invalid="isNull(consumoalqueire)"
                    :max="9999999"
                    tooltipLabel="informacao-alqueire"
                    tooltipSize="is-small"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="hectareInput"
                    title="consumohectare"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="consumohectare"
                    @input="hectareUpdate"
                    :invalid="isNull(consumohectare)"
                    :max="9999999"
                    tooltipLabel="informacao-hectare"
                    tooltipSize="is-small"
                />
            </div>
        </div>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="produtos"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="produtosSelecionados"
                :custom-is-checked="
                    (selecionados, linha) => selecionados.idproduto === linha.idproduto
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AgroAssNivelTecnologicoProdutoService from '@/services/agro/nivel-tecnologico/AgroAssNivelTecnologicoProdutoService';

// MENSAGENS
import Message from '@/models/Message';

/* @71224 - Cadastro de nível tecnológico - Aba insumos */
export default {
    props: {
        idagroniveltecnologico: 0,
    },
    data() {
        return {
            service: new AgroAssNivelTecnologicoProdutoService(this.$http, this.$router),
            produtos: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'produto', width: null, sortable: true, sortFn: null },
                { key: 'familia', width: null, sortable: true, sortFn: null },
            ],
            produtosSelecionados: [],
            idproduto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'produto',
            order: 'asc',
            msgs: [],
            consumoalqueire: 0,
            consumohectare: 0,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;
            this.service
                .findNaoAssociados(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idagroniveltecnologico,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtos = value;
                    this.isEmpty = this.produtos.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idagroniveltecnologico: this.$route.params.id,
                    idproduto: m.idproduto,
                    codigo: m.idprodutoerp,
                    produto: m.descricao,
                    familia: m.produtoFamilia.descricao,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.produtosSelecionados.length > 0) {
                this.isLoading = true;
                let tempSelecionados = [];
                this.produtosSelecionados.forEach((e) => {
                    tempSelecionados.push({
                        idagroniveltecnologico: this.idagroniveltecnologico,
                        consumoalqueire: this.consumoalqueire,
                        consumohectare: this.consumohectare,
                        idproduto: e.idproduto,
                    });
                });
                this.service
                    .save(tempSelecionados)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$emit('fecharModal', true);
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-produto', true));
                this.isLoading = false;
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
        alqueireUpdate(value) {
            this.consumoalqueire = value;
        },
        hectareUpdate(value) {
            this.consumohectare = value;
        },
        generateId(numberId) {
            return this.$route.name + '-produto-' + numberId;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
